// CLIENT CONFIG (public)
export const JOB_POST_PUBLISH_DURATION_IN_DAYS = 28;
export const ES_DEFAULT_DISTANCE_IN_KM = 100;
export const TAG_SCORE_THRESHOLD = 30;
export const QUALITY_SCORE_THRESHOLD = 30;
export const ORGANISATIONS_AUTOCOMPLETE_LIMIT = 10;
